module.exports = __webpack_public_path__ + "img/select_arrow.867614c8.svg";